/** Plausible script URL — keep in sync with src/utils/plausibleInit.js. */
export const PLAUSIBLE_SCRIPT_SRC =
  process.env.REACT_APP_PLAUSIBLE_SCRIPT_SRC ||
  'https://plausible.io/js/pa-D1WlxMRssD-ig-DzmWD3x.js';

/** Prod backend — Plausible runs only when this API host is configured at build time. */
export const PLAUSIBLE_PROD_API_HOST = 'vectors.daivbharathi.com';

/** Public website hostnames where prod traffic is served (not the API subdomain). */
const PLAUSIBLE_SITE_HOSTS = ['daivbharathi.com', 'www.daivbharathi.com'];

/** Local hosts — only when REACT_APP_PLAUSIBLE_ENABLED=true (testing). */
const PLAUSIBLE_TEST_HOSTS = ['localhost', '127.0.0.1'];

function parseHostname(url) {
  try {
    return new URL(String(url || '')).hostname.toLowerCase();
  } catch {
    return '';
  }
}

/** TEMP: stop all Plausible events (script + https://plausible.io/api/event). Set false to resume. */
export const PLAUSIBLE_TEMP_DISABLED = true;

/** Explicit test override — TEMP: set false / remove after local testing. */
export function isPlausibleTestMode() {
  if (PLAUSIBLE_TEMP_DISABLED) return false;
  return process.env.REACT_APP_PLAUSIBLE_ENABLED === 'true';
}

/** True when this build targets prod (vectors.daivbharathi.com API). */
export function isPlausibleProdBuild() {
  if (PLAUSIBLE_TEMP_DISABLED) return false;
  if (process.env.REACT_APP_PLAUSIBLE_ENABLED === 'false') return false;
  if (isPlausibleTestMode()) return true;

  const apiHost = parseHostname(process.env.REACT_APP_API_BASE_URL);
  return apiHost === PLAUSIBLE_PROD_API_HOST;
}

export function isPlausibleAllowedHost(hostname) {
  const host = String(hostname || '').toLowerCase();
  if (PLAUSIBLE_SITE_HOSTS.includes(host)) return true;
  // Local testing only when explicitly enabled
  if (isPlausibleTestMode() && PLAUSIBLE_TEST_HOSTS.includes(host)) return true;
  return false;
}

export function isPlausibleAllowedOnCurrentHost() {
  if (typeof window === 'undefined') return false;
  if (PLAUSIBLE_TEMP_DISABLED) return false;
  if (!isPlausibleProdBuild()) return false;
  if (window.__daivPlausibleAllowed === false) return false;
  return isPlausibleAllowedHost(window.location.hostname);
}
